import React from 'react';

import { AccordionRoot, AccordionTab } from 'ui/elements/Accordion';

type CartSummaryAccordionProps = {
  bodyClassNameConfig?: {
    baseClassName?: string;
  };
  className?: string;
  dataTestId?: string;
  expanded?: boolean;
  headerClassNameConfig?: {
    baseClassName?: string;
    expanded?: string;
    closed?: string;
  };
  id: string;
  title: string;
};

export const CartSummaryAccordion: React.FC<CartSummaryAccordionProps> = ({
  bodyClassNameConfig,
  children,
  className,
  dataTestId,
  expanded = true,
  headerClassNameConfig,
  id,
  title,
}) => (
  <AccordionRoot>
    <AccordionTab
      className={className}
      dataTestId={dataTestId}
      expand={expanded}
      headerClassNameConfig={headerClassNameConfig}
      bodyClassNameConfig={bodyClassNameConfig}
      id={id}
      title={title}
    >
      {children}
    </AccordionTab>
  </AccordionRoot>
);
